import { useRegistroMercantil } from "api/Empresa.hook"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import TabNav from "common/components/TabNav"
import { SEARCH_PARAMS } from "common/constants"
import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import { getSearchParams } from "common/utils/utils"
import { getDefaultCountry } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { ProgressSpinner } from "primereact/progressspinner"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import Actividad from "../../forms/PerfilEmpresa/Actividad"
import Contacto from "../../forms/PerfilEmpresa/Contacto"
import Direcciones from "../../forms/PerfilEmpresa/Direcciones"
import Empresa from "../../forms/PerfilEmpresa/Empresa"
import Logo from "../../forms/PerfilEmpresa/Logo"
import {
  fetchDireccionesEmpresa,
  fetchFormasContactoEmpresa,
} from "../../redux/slices/empresaSlice"
import IntregrationsBanner from "./components/IntregrationsBanner"
import "./perfilEmpresa.scss"

const PerfilEmpresa = () => {
  const { t } = useTranslation()
  const {
    activeCompany,
    activeCompanyMutation,
    activeCompanyIsLoading,
    activeCompanyMutationSucces,
  } = useUsuarioEmpresaActiva()
  const {
    activeCompanyRegistroMercantil,
    activeCompanyRegistroMercantilIsLoading,
    activeCompanyRegistroMercantilMutation,
  } = useRegistroMercantil(activeCompany?.id)
  const location = useLocation()
  const param = getSearchParams(location, SEARCH_PARAMS.GOTO)
  const [tabSelected, setTabSelected] = useState(
    param === SEARCH_PARAMS.CUENTA_BANCARIA ? 3 : 0
  )

  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const country = useSelector(getDefaultCountry)
  const isDefaultCountry = country === DEFAULT_COUNTRY_SELECTED

  useEffect(() => {
    setLoading(true)

    Promise.all([
      dispatch(fetchFormasContactoEmpresa()),
      dispatch(fetchDireccionesEmpresa()),
    ]).then(() => setLoading(false))
  }, [dispatch])

  return (
    <div className='p-4 m-0 overflow-auto row position-relative align-items-start justify-content-center'>
      <div className='w-full mt-3 col-md-12 col-lg-12 col-xl-9 d-flex flex-column justify-content-center'>
        <div className='justify-start w-full my-2 mt-1 d-flex'>
          <span className='text-gedesco f-21 f-weight-500'>
            {t("perfilEmpresa.title")}
          </span>
        </div>
        <IntregrationsBanner />

        {loading ? (
          <div style={{ height: "50vh" }}>
            <ProgressSpinner
              style={{ width: "50px", height: "50px", top: "50%" }}
              strokeWidth='4'
              animationDuration='.5s'
            />
          </div>
        ) : (
          <div className='tw-px-10 tw-py-6 forms-container tw-bg-simple-10 tw-rounded-xl'>
            <TabNav
              tabs={[
                {
                  header: `${t("perfilEmpresa.headerCompany")}`,
                  id: 0,
                },
                {
                  header: `${t("perfilEmpresa.headerDirection")}`,
                  id: 1,
                  hide: !activeCompany?.verificada,
                },
                {
                  header: `${t("perfilEmpresa.headerContact")}`,
                  id: 2,
                  hide: !activeCompany?.verificada,
                },
                {
                  header: `${t("perfilEmpresa.headerBankAcount")}`,
                  id: 3,
                  hide: !activeCompany?.verificada,
                },
              ]}
              active={tabSelected}
              setActive={setTabSelected}
            />
            {tabSelected === 0 && !activeCompanyIsLoading && (
              <>
                <Empresa
                  // @ts-expect-error TS(2322): Type '{ t: TFunction<"translation", undefined, "tr...
                  t={t}
                  activeCompany={activeCompany}
                />

                {activeCompany?.verificada && <Logo />}

                {activeCompany?.verificada &&
                  isDefaultCountry &&
                  !activeCompanyIsLoading &&
                  !activeCompanyRegistroMercantilIsLoading && (
                    <>
                      <Actividad
                        t={t}
                        activeCompany={activeCompany}
                        updateActiveCompany={activeCompanyMutation}
                        activeCompanyUpdateSuccess={activeCompanyMutationSucces}
                        registroMercantil={activeCompanyRegistroMercantil}
                        updateRegistroMercantil={
                          activeCompanyRegistroMercantilMutation
                        }
                      />
                    </>
                  )}
              </>
            )}
            {tabSelected === 1 && <Direcciones />}
            {tabSelected === 2 && <Contacto />}
          </div>
        )}
      </div>
    </div>
  )
}
export default PerfilEmpresa
